/*
* Product Image ScrollTo Interaction
*
**/

import 'slick-carousel';

custom.inlineSyncCarousel = (() => {

	const blockClass = 'js-inline-sync-carousel';
	const imgBlockClass = 'js-inline-sync-carousel--image';
	const textBlockClass = 'js-inline-sync-carousel--text';

	const imgConfig = {
		infinite: false,
		dots: true,
		arrows: false,
		fade: true
	};
	const textConfig = {
		infinite: false,
		dots: false,
		arrows: false,
		fade: true
	};

	function syncCarousel(index) {
		const $carousel = $(`[data-${blockClass}-id="${index}"]`);

		$carousel.find(`.${imgBlockClass}`).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
			$carousel.find(`.${textBlockClass}`).slick('slickGoTo', nextSlide);
		});
	}

	function initHandler(index) {
		const $carousel = $(`[data-${blockClass}-id="${index}"]`);

		$carousel.find(`.${imgBlockClass}`).slick(imgConfig);
		$carousel.find(`.${textBlockClass}`).slick(textConfig);
	}

	function init() {
		if($(`.${blockClass}`).length > 0) {
			$.each($(`.${blockClass}`), (index, el) => {
				$(el).attr(`data-${blockClass}-id`, index);

				initHandler(index);
				syncCarousel(index);
			});
		}
	}

	return {
		init: init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/inline-sync-carousel.js